import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "./signin.css";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotPassword,
  login,
  reSendVerificationCode,
  resetPassword,
  signinmodalclose,
  closeSigninModal,
} from "../../store/reducers";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import SendIcon from "@mui/icons-material/Send";
import { encryptAndStoreData } from "./encript-decript";
import CryptoJS from "crypto-js";

function SignIn({ side }) {
  const [show, setShow] = useState(false);
  const [isopen, setisopen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = localStorage.getItem('path');
  
  // Get modal state from Redux
  const signinModalState = useSelector(state => state.counter?.signinModalState);
  const { showModel, isOpen, isRegisterMode, onClose } = useSelector(state => ({
    showModel: state.counter?.showModel,
    isOpen: state.counter?.signinModalState?.isOpen,
    isRegisterMode: state.counter?.signinModalState?.isRegisterMode,
    onClose: state.counter?.signinModalState?.onClose
  }));

  console.log('SignIn - showModel:', showModel);
  console.log('SignIn - isOpen:', isOpen);
  console.log('SignIn - isRegisterMode:', isRegisterMode);
  console.log('SignIn - onClose callback exists:', !!onClose);

  const handleClose = () => {
    console.log('SignIn close button clicked');
    
    // Call the external onClose callback if it exists (from CompanyClaim)
    if (onClose && typeof onClose === 'function') {
      console.log('Calling external onClose callback');
      onClose();
    }
    
    setShow(false);
    dispatch(signinmodalclose());
    dispatch(closeSigninModal());
  };

  const handleShow = () => {
    setShow(true);
    setisopen(false);
  };

  const handleforgotpassword = () => {
    setisopen(true);
    setShow(false);
  };

  const handleforgotclose = () => {
    setisopen(false);
    setResetNew(false);
  };

  const initialValue = { email: "", password: "" };
  const SignInSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address format")
      .required("Required"),
    password: Yup.string()
      .min(8, "Password must be 8 characters at minimum")
      .required("Required"),
  });

  const initialValue1 = { email: "" };

  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address format")
      .required("Required"),
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    const payload = {
      email: values.email,
      password: values.password,
    };

    setLoading(true);
    dispatch(login(payload))
      .then((data) => {
        if (data.payload.name) {
          const nameParts = data.payload.name.split(" ");
          const firstLetter = nameParts[0].charAt(0).toUpperCase();
          const secondLetter = nameParts.length > 1 ? nameParts[1].charAt(0).toUpperCase() : "";
          const initials = `${firstLetter}${secondLetter}`;
          localStorage.setItem('userName', data.payload.name);
          encryptAndStoreData("user", initials, "123456789");
        }

        if (data?.payload?.access_token) {
          setLoading(false);
          toast.success("Login successfully!");
          setShow(false);
          dispatch(closeSigninModal());
          
          // First priority: Check if there's a pending claim link (from closed modal)
          const pendingClaimLink = localStorage.getItem('pendingClaimLink');
          if (pendingClaimLink) {
            console.log('Redirecting to pending claim link:', pendingClaimLink);
            localStorage.removeItem('pendingClaimLink');
            navigate(pendingClaimLink);
            return;
          }
          
          // Second priority: Check if there's a pending company claim (from session)
          const pendingClaim = sessionStorage.getItem('pendingCompanyClaim');
          if (pendingClaim) {
            const claimData = JSON.parse(pendingClaim);
            navigate(`company/claim/${claimData.company_id}`);
            return;
          }
          
          // Third priority: Navigate to saved path or dashboard
          if (path) {
            navigate(path);
          } else {
            navigate("/dashboard");
          }
        } else {
          setLoading(false);
          console.log("login response",data.payload);
          
          toast.error(data.payload || "Login failed");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message || "Something went wrong");
      });
  };

  const [resetNew, setResetNew] = useState(false);
  const [sending, setSending] = useState(false);

  const initialResetNew = {
    email: localStorage.getItem("USERNAME_TO_CONFIRM"),
    password: "",
    code: "",
  };

  const resetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address format")
      .required("Required"),
    password: Yup.string()
      .min(3, "Password must be 3 characters at minimum")
      .required("Required"),
    code: Yup.string().required("Required"),
  });

  const handleNewReserSubmit = (values) => {
    setLoading(true);
    dispatch(resetPassword(values))
      .then((data) => {
        setLoading(false);
        toast.success(data?.payload);
        setisopen(false);
        setShow(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const resend = () => {
    setSending(true);
    dispatch(
      reSendVerificationCode(localStorage.getItem("USERNAME_TO_CONFIRM"))
    )
      .then((data) => {
        setSending(false);
        toast.success(data?.payload);
      })
      .catch(() => {
        setSending(false);
      });
  };

  const handleSubmit1 = (values) => {
    localStorage.setItem("USERNAME_TO_CONFIRM", values.email);
    dispatch(forgotPassword(values.email))
      .then((data) => {
        toast.success(data?.payload);
        setResetNew(true);
      })
      .catch((e) => console.log(e));
  };

  // Determine if modal should be open
  const isModalOpen = show || showModel || isOpen;

  return (
    <div className={!side ? 'nav-button-wi' : 'side-nav-btn'}>
      <button className="btn-outline-dark" onClick={handleShow}>
        SIGN IN
      </button>

      {isopen ? (
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          id="popupDialog"
          open={isopen}
          onClose={handleforgotclose}
          scroll={"body"}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogContent className="popup">
            <div className="flex-row exit-button">
              <IconButton
                className={"float-end p-0"}
                color="inherit"
                onClick={handleforgotclose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div className="flex-row">
              <div className="popup-img"></div>

              {resetNew ? (
                <div className="popup-content">
                  <div>
                    <h2>Reset password</h2>
                    <p>
                      If an account exists for the provided address you'll
                      receive an email with a reset code soon
                    </p>
                    <Formik
                      initialValues={initialResetNew}
                      validationSchema={resetPasswordSchema}
                      onSubmit={handleNewReserSubmit}
                    >
                      {({ errors, touched, isValidating }) => (
                        <Form className={"mt-5"}>
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <Field
                                  name="email"
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      className={`form-control`}
                                      disabled={true}
                                      type="text"
                                      placeholder="Email address"
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <Field
                                  type={"password"}
                                  name="password"
                                  placeholder="New password"
                                  className={`form-control ${touched.password && errors.password
                                      ? "is-invalid"
                                      : ""
                                    }`}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="password"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-1">
                              <div className="form-group">
                                <Field
                                  name="code"
                                  placeholder="Code"
                                  className={`form-control ${touched.code && errors.code
                                      ? "is-invalid"
                                      : ""
                                    }`}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="code"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {!sending ? (
                              <button
                                onClick={resend}
                                style={{ cursor: "pointer" }}
                                id="resend-code"
                                className="greenLinkBtn mb-5"
                              >
                                {!sending ? "Resend Code" : "Sending ..."}
                              </button>
                            ) : (
                              "Sending ..."
                            )}

                            <div className="col-md-12">
                              {loading ? (
                                <LoadingButton
                                  endIcon={<SendIcon />}
                                  className="mb-3 w-100"
                                  loading
                                  loadingPosition="end"
                                  variant="contained"
                                >
                                  LOADING...
                                </LoadingButton>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary mb-3 w-100 m-0"
                                >
                                  RESET PASSWORD
                                </button>
                              )}
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              ) : (
                <div className="popup-content">
                  <h2>Password Reset</h2>
                  <p>
                    Submit your account email below to receive a code you can
                    then use to reset your password
                  </p>
                  <Formik
                    initialValues={initialValue1}
                    validationSchema={forgotPasswordSchema}
                    onSubmit={handleSubmit1}
                  >
                    {({ errors, touched, isValidating }) => (
                      <Form className={"mt-3"}>
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <div className="form-group">
                              <Field
                                name="email"
                                placeholder="Email address"
                                className={`form-control ${touched.email && errors.email
                                    ? "is-invalid"
                                    : ""
                                  }`}
                              />
                              <ErrorMessage
                                component="div"
                                name="email"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <button
                              type="submit"
                              className="btn btn-primary mb-3 w-100 m-0"
                            >
                              SEND RESET CODE
                            </button>
                          </div>

                          <div
                            style={{
                              justifyContent: "center",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                alignItems: "center",
                                display: "flex",
                              }}
                              className="greenLinkBtn"
                              onClick={handleShow}
                            >
                              <KeyboardArrowLeft />
                              <span>Back to Login</span>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              )}
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          id="popupDialog"
          open={isModalOpen}
          onClose={handleClose}
          scroll={"body"}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogContent className="popup">
            <div className="flex-row exit-button">
              <IconButton
                className={"float-end p-0"}
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div className="flex-row">
              <div className="popup-img"></div>
              <div className="popup-content">
                <h2 className="mb-5">Welcome Back!</h2>
                <Formik
                  initialValues={initialValue}
                  validationSchema={SignInSchema}
                  onSubmit={handleSubmit}
                >
                  {({ errors, touched, handleSubmit }) => (
                    <Form
                      onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                    >
                      <div className="row">
                        <b>Login Email</b>
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              name="email"
                              placeholder="Email address"
                              className={`form-control ${touched.email && errors.email
                                  ? "is-invalid"
                                  : ""
                                }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="email"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <b>Password</b>
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              type="password"
                              name="password"
                              placeholder="Password"
                              className={`form-control ${touched.password && errors.password
                                  ? "is-invalid"
                                  : ""
                                }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="password"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <button
                          onClick={handleforgotpassword}
                          type="button"
                          style={{ cursor: "pointer" }}
                          id="forgot-pass"
                          className="greenLinkBtn"
                        >
                          Forgot password?
                        </button>
                        <div className="col-md-12">
                          {loading ? (
                            <LoadingButton
                              endIcon={<SendIcon />}
                              className="mb-3 w-100"
                              loading
                              loadingPosition="end"
                              variant="contained"
                            >
                              LOADING..
                            </LoadingButton>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary mt-5 mb-4 w-100"
                            >
                              SIGN IN
                            </button>
                          )}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

export default SignIn;